import React, { Component } from 'react';
const vis_node = '#8ae234';
const undis_node = '#EEEEEC';
const dis_node = '#fcaf3e';
const act_node = '#729fcf';
export default class DijTutIns extends Component {
    render() {
        return (
            <div className="left-div">
                <h3>Objective</h3>
                <p>
                    Given a directed graph with non-negative weights, find the
                    shortest path from the source node to every node in the
                    graph.
                </p>
                <h3>Color codes</h3>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: vis_node }}
                    ></div>
                    <p>Visited Node</p>
                </div>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: act_node }}
                    ></div>
                    <p>Active Node</p>
                </div>

                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: dis_node }}
                    ></div>
                    <p>Discovered Node</p>
                </div>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: undis_node }}
                    ></div>
                    <p>Undiscovered Node</p>
                </div>
                <h3>Setup</h3>
                <p>
                    Click on 'Next' button and follow the steps of the
                    dijkstra's algorithm.
                </p>
                <h3>Procedure</h3>
                <p>
                    Step 1: Click on the Next button to step through the
                    algorithm.
                </p>
                <p>
                    Step 2: When the queue is empty, the distance array has the
                    shortest distance fromt the source node to every other node.
                </p>
            </div>
        );
    }
}
